import { get, isEmpty } from "lodash";
import { useFormStore } from "@/shared/forms";
import type { BaseFieldSet } from "./types";

export function useGridHeaderVisible<AssertionsEnum extends string, FieldSet extends BaseFieldSet<AssertionsEnum>>(
    fieldsets: FieldSet[],
    fieldSetToFormArrayPathFn: (fieldSet: FieldSet) => string,
) {
    const isGridHeaderVisible = useFormStore(({ values }) =>
        fieldsets.some((fieldset) => {
            const fieldPath = fieldSetToFormArrayPathFn(fieldset);
            const fieldValue = get(values, fieldPath);
            return !isEmpty(fieldValue);
        }),
    );

    return isGridHeaderVisible;
}
